module.exports = __webpack_public_path__ + "img/Groupe 75.15dad322.svg";